import { Button } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Slider } from '@progress/kendo-react-inputs';
import { useCallback, useEffect, useState } from 'react';
import { CloseOutline, DoubleChevronRightOutline } from '../../../../icons/icons';
import { EventBus } from '../../../contexts/event-bus';
import { useAppDispatch } from '../../../hooks/store-hooks';
import { patchFocusedWorkspace } from '../../../state/store';
import { useWorkspace } from '../hooks/use-view';

export function FlightForwardControls() {
    const forward = useWorkspace((x) => x.flights.fastForward);
    const [value, setValue] = useState(0);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setValue(0);
    }, [forward]);

    const close = useCallback(() => {
        dispatch(patchFocusedWorkspace((x) => (x.flights.fastForward = { active: false })));
    }, [forward]);

    if (!forward.active) {
        return null;
    }

    return (
        <div className="k-card px-1 w-50 d-flex flex-row align-items-center gap-2 mx-auto">
            <div className="d-flex align-items-center gap-1">
                <SvgIcon icon={DoubleChevronRightOutline} size="small" />
                <div>Flight fast forward</div>
            </div>
            {(forward.points?.length ?? 0) >= 3 ? (
                <Slider
                    disabled={(forward.points?.length ?? 0) < 3}
                    className="flex-grow-1"
                    min={0}
                    max={(forward.points?.length ?? 1) - 1}
                    value={value}
                    step={1}
                    largeStep={1}
                    onChange={(e) => {
                        setValue(Math.round(e.value));
                        EventBus.fire('fast-forward-progress', Math.round(e.value));
                    }}
                />
            ) : (
                <div className="flex-grow-1 text-center fw-bold">Not enough route points to destination.</div>
            )}
            <Button title={'Close'} svgIcon={CloseOutline} fillMode="flat" className="button-small" onClick={close} />
        </div>
    );
}
